import React, { useEffect, useState } from 'react';

import { Button, DatePicker, Form, Input, Space, Spin, message } from 'antd';
import dayjs from 'dayjs';

import CmbClienti from '../../Combos/CmbClienti';
import sessionManager, { eVariableType } from '../../SessionManager';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import { ViaggioDettaglioModel } from '../Models/CRMViaggiModels';

interface ViaggioDettagliAddEditProps {
    idViaggio: number | null;
    confirm: boolean;
    viaggioDettaglio: ViaggioDettaglioModel | null;
    close: (esito: boolean) => void;
}

export default function ViaggioDettagliAddEdit(props: ViaggioDettagliAddEditProps) {
    const [frm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        LoadData();
    }, []);

    async function LoadData() {
        try {
            setIsLoading(true);

            const query: string =
                '?idSocieta=' +
                sessionManager.get(eVariableType.IDSocieta)?.toString() +
                '&idViaggio=' +
                props.viaggioDettaglio?.idViaggio?.toString() +
                '&numRiga=' +
                props.viaggioDettaglio?.numRiga?.toString();
            const res = await api.get('CRM/Viaggi/Dettagli' + query);

            if (res.data !== null) {
                const l: ViaggioDettaglioModel = res.data[0];

                if (l.idViaggio !== null) {
                    frm.setFieldValue('data', dayjs(l.data));
                    frm.setFieldValue('descrizione', l.descrizione);
                    frm.setFieldValue('codCliente', l.codCliente);
                    frm.setFieldValue('ragioneSociale', l.ragioneSociale);
                }
            }
        } catch (error) {
            GetErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    }

    async function salva() {
        try {
            setIsLoading(true);
            const dt: ViaggioDettaglioModel = {
                idViaggio: props.idViaggio,
                numRiga: props.viaggioDettaglio?.numRiga,
                idSocieta: Number(sessionManager.get(eVariableType.IDSocieta)),
                codCliente: frm.getFieldValue('codCliente'),
                data: frm.getFieldValue('data'),
                descrizione: frm.getFieldValue('descrizione'),
                ragioneSociale: '',
            };
            const res = await api.post('CRM/Viaggi/Dettagli/Insert', dt);

            if (res.data !== null) {
                message.success(stringres.t('successo').toString());
                props.close(true);
            }
        } catch (error) {
            GetErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div>
            <Spin spinning={isLoading}>
                <Form.Provider>
                    <Form form={frm} onFinish={salva}>
                        <div></div>
                        <Form.Item name="codCliente" rules={[{ required: true }]}>
                            <CmbClienti
                                ragioneSociale={frm?.getFieldValue('ragioneSociale')}
                                value={frm?.getFieldValue('codCliente')}
                                onselected={(e) => frm.setFieldsValue({ codCliente: e.codCliente })}
                            ></CmbClienti>
                        </Form.Item>
                        <Form.Item name="data" rules={[{ required: true }]}>
                            <DatePicker></DatePicker>
                        </Form.Item>
                        <Form.Item name="descrizione" rules={[{ required: true }]}>
                            <Input.TextArea
                                rows={4}
                                placeholder={stringres.t('descrizione').toString()}
                            ></Input.TextArea>
                        </Form.Item>
                        <Form.Item>
                            <Space>
                                <Form.Item>
                                    <Button type="primary" onClick={() => props.close(false)}>
                                        {stringres.t('annulla').toString()}
                                    </Button>
                                </Form.Item>
                                <Form.Item>
                                    <Button htmlType="submit" type="primary">
                                        {stringres.t('conferma').toString()}
                                    </Button>
                                </Form.Item>
                            </Space>
                        </Form.Item>
                    </Form>
                </Form.Provider>
            </Spin>
        </div>
    );
}
